module.exports = __webpack_public_path__ + "img/dp.e69773a4.png";